export const CloudVendor = {
    Azure: "Azure",
    AWS: "AWS",
} as const;

export const CloudVendorLower = {
    Azure: "azure",
    AWS: "aws"
} as const